import { InsurancePolicy } from '@/types/insurancePolicy';

const getDefaultInsurancePolicy = (
  insurancePolicies: InsurancePolicy[]
): InsurancePolicy | undefined => {
  return insurancePolicies.find((policy) => policy.is_default);
};

export default getDefaultInsurancePolicy;
